module.exports = __webpack_public_path__ + "static/media/40.526b22ba.png";